import styled from "styled-components";

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 32px;
`;

export const PageTitle = styled.h1`
  font-size: 20px;
  font-weight: 600;
  line-height: 26px;
  color: #1f2937;

  @media (max-width: 480px) {
    font-size: 19px;
    line-height: 25px;
  }
`;

export const OtherBanksWrapper = styled.div`
  border: 2px solid #e5e7eb;
  margin-top: 24px;
  border-radius: 16px;

  @media (max-width: 480px) {
    margin-top: 22px;
  }
`;

export const OtherBanksContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 24px;

  @media (max-width: 480px) {
    padding: 18px 16px;
  }
`;

export const OtherBankHeaderWrapper = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;

  @media (max-width: 480px) {
    align-items: flex-start;
    gap: 10px;
  }
`;

export const LogoWrapper = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: ${(props) => `${props.radius}px`};
  padding: ${(props) => `${props.padding}px`};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const OtherBankDescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

export const WithOtherBank = styled.h6`
  font-size: 14px;
  font-weight: 600;
  line-height: 140%;
  color: #1f2937;
  margin: 0;
`;

export const WithOtherBankDesc = styled.p`
  font-size: 13px;
  font-weight: 400;
  line-height: 140%;
  color: #374151;
  margin: 0;
`;

export const ChooseBank = styled.h5`
  font-size: 17px;
  font-weight: 600;
  line-height: 16.5px;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 20px;

  @media (max-width: 480px) {
    font-size: 15px;
    line-height: 18px;
    margin-top: 18px;
  }
`;

export const BankRadioInputsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 10px;
`;

export const BankWrapper = styled.div`
  display: flex;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  flex: 1;
`;

export const BankContent = styled.div`
  display: flex;
  padding: 10px 14px;
  justify-content: space-between;
  align-items: center;
  float: 1;
  width: 100%;

  @media (max-width: 480px) {
    padding: 9px 12px;
    gap: 10px;
  }
`;

export const LogoAndNameWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;

  @media (max-width: 480px) {
    gap: 10px;
  }
`;

export const BankName = styled.h5`
  font-size: 14px;
  font-weight: 600;
  line-height: 19.5px;
  color: #1f2937;
  margin: 0;
`;

export const ProcreditBankWrapper = styled.div`
  display: flex;
  border: 2px solid #e5e7eb;
  border-radius: 16px;
  flex: 1;
  margin-top: 16px;
`;

export const ProcreditBankContent = styled.div`
  display: flex;
  padding: 20px 24px;
  justify-content: space-between;
  align-items: center;
  float: 1;
  gap: 16px;
  width: 100%;

  @media (max-width: 480px) {
    position: relative;
    align-items: flex-start;
    padding: 18px 16px;
    gap: 10px;
  }
`;

export const ProcrditLogoAndNameWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;

  @media (max-width: 480px) {
    align-items: flex-start;
    gap: 10px;
    padding-right: 26px;
  }
`;

export const WithProcreditWrapper = styled.h5`
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
  margin: 0;
`;

export const WithProcredit = styled.h5`
  font-size: 14px;
  font-weight: 600;
  line-height: 19.5px;
  color: #1f2937;
  margin: 0;
`;
export const WithProcreditDesc = styled.h5`
  font-size: 13px;
  font-weight: 400;
  line-height: 19.5px;
  color: #374151;
  margin: 0;

  @media (max-width: 480px) {
    line-height: 18px;
  }
`;

export const RadioInput = styled.input`
  flex-shrink: 0;

  @media (max-width: 480px) {
    ${ProcreditBankContent} > & {
      position: absolute;
      top: 18px;
      right: 16px;
    }
  }
`;
